import state from './vto-state'
import getters from './vto-getters'
import actions from './vto-actions'
import mutations from './vto-mutations'

/**
 * Here, we simply aggregate the definitions laid
 * out in each of the state, getter, action and
 * mutation files within this Vuex module.
 */
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
